import {
  OrgConfigResponse,
  OrgConfigUpdateRequest,
} from "@arrowsup/platform-dtos";
import { AxiosInstance } from "axios";

export interface OrgConfigService {
  getConfig: () => Promise<OrgConfigResponse>;
  updateConfig: (data: OrgConfigUpdateRequest) => Promise<OrgConfigResponse>;
  refreshToken: () => Promise<{ token: string }>;
}

class OrgConfigServiceImpl implements OrgConfigService {
  constructor(private readonly api: AxiosInstance) {}

  readonly getConfig = async (): Promise<OrgConfigResponse> => {
    const resp = await this.api.get<OrgConfigResponse>(`/api/org-config`);
    return resp.data;
  };

  readonly updateConfig = async (
    data: OrgConfigUpdateRequest
  ): Promise<OrgConfigResponse> => {
    const resp = await this.api.put<OrgConfigResponse>(`/api/org-config`, data);
    return resp.data;
  };

  readonly refreshToken = async (): Promise<{ token: string }> => {
    const resp = await this.api.post<{ token: string }>(
      `/api/org-config/refresh-token`
    );
    return resp.data;
  };
}

export const useOrgConfigService = (api: AxiosInstance): OrgConfigService => {
  return new OrgConfigServiceImpl(api);
};
